import { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'

export const Radio = ({
  questiondata,
  onChange,
  currentValue,
  inverted = false,
  questionNumber = 0,
}: {
  questiondata: Question
  onChange: (
    id: string,
    value: string | number,
    questionNumber?: number
  ) => void
  currentValue: string | number | undefined
  inverted?: boolean
  questionNumber?: number
}) => {
  const [selected, setSelected] = useState<any>()
  const { id, options } = questiondata
  if (!options) throw new Error('Radio: options missing')

  useEffect(() => {
    if (currentValue) setSelected(currentValue)
  }, [currentValue])

  return (
    <Fields
      style={{ border: 'none', padding: 0, margin: 0 }}
      role='radiogroup'
      aria-labelledby={id}
    >
      {options.map((option, i) => {
        const { value, label } = option
        return (
          <Fragment key={'radiobutton_' + i}>
            <Label
              $inverted={inverted}
              style={{
                backgroundColor:
                  value === selected ? 'var(--input-active-color)' : undefined,
                color:
                  value === selected ? '#fff' : undefined,
              }}
            >
              <RadioInput
                onChange={() => {
                  setSelected(value)
                  onChange(id, value, questionNumber)
                }}
                checked={i === selected}
                name={id}
                id={id + '_' + i}
                type='radio'
                value={value}
              />
              {label}
            </Label>
          </Fragment>
        )
      })}
    </Fields>
  )
}

const Fields = styled.fieldset`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`
const Label = styled.label<{ $inverted?: boolean }>`
  padding: 10px;
  font-size: 15px;
  flex: 0 0 calc(50% - 25px);
  display: inline-block;
  line-height: 1.2em;
  background-color: ${(props) =>
    props.$inverted
      ? 'var(--input-unselected-bg-inverted)'
      : 'var(--input-unselected-bg)'};
  color: var(--text-color);
  @media screen and (min-width: 712px) {
    &:hover {
      cursor: pointer;
      background-color: var(--purple-main);
      color: var(--brandblue-main);
    }
  }
`
const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:hover {
    color: var(--text-color);
    background-color: var(--site-background);
  }
  &:checked{
    color: var(--text-color);
  }
  // When the label is hovered, apply styles to the radio button
  /* ${Label}:hover & {
    color: var(--text-color);
    background-color: var(--site-background);
  } */
`
